const siteConfig = {
  brandName: "trbanlantern",
  logoText: "trbanlantern",
  logo: {
    text: "trbanlantern",
    favicon: "/favicon.svg",
  },
  tagline: "Quiet design for everyday movement.",
  description:
    "A considered wardrobe of soft layers, relaxed tailoring and everyday essentials designed for movement, comfort and lasting wear.",
  contact: {
    email: "smart@trbanlantern.xyz",
    address:
      "RM. 517, New City Centre, 2 Lei Yue Mun Road, Kwun Tong, Kowloon, Hong Kong",
    location: "Kwun Tong, Kowloon, Hong Kong",
    hours: "Monday–Friday, 09:00–17:00 HKT",
    supportLabel: "Help & Contact",
  },
  business: {
    legalName: "JIA LI SI TRADING LIMITED",
  },
  socials: {},
  collections: {
    coreLabel: "TRBANLANTERN CORE",
  },
  currency: "USD",
  locale: "en-US",
  shipping: {
    flatRate: 15,
    freeThreshold: 200,
    returnDays: 30,
    standardDeliveryDays: "2–4 business days",
    expressDeliveryDays: "1–2 business days",
    sameDayDispatchCutoff: "20:00",
  },
  freeShipping: {
    threshold: 50,
    countries: ["HK"],
  },
  returns: {
    windowDays: 30,
    policyPath: "/returns",
    summary: "Return unworn items in their original condition within 30 days.",
  },
  copyright: "trbanlantern",
};

export const formatPrice = (value, options = {}) => {
  const numericValue =
    typeof value === "number"
      ? value
      : Number.parseFloat(String(value).replace(",", "."));

  if (!Number.isFinite(numericValue)) {
    return "";
  }

  const locale = options.locale || siteConfig.locale;
  const currency = options.currency || siteConfig.currency;

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numericValue);
};

export default siteConfig;
